// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2v_fA","header":"MergedInvoice_header__F_2nm"};